import { Component, OnInit } from "@angular/core";
import { HelperService } from "@app/services/helper.service";
import { SubjectService } from "@app/services/subject.service";
import { PubSubService } from "@services/pubsub.service";
import { Tabs } from "@config/constants";

@Component({
  selector: "app-my-clients-tabs",
  templateUrl: "./my-clients-tabs.component.html",
  styleUrls: ["./my-clients-tabs.component.scss"],
})
export class MyClientsTabsComponent implements OnInit {
  public activeQuota: boolean = false;
  public currentTab: Tabs;
  public tabs = Tabs;

  public navItemTabs = [
    {
      href: "#data-update",
      description: "Actualización de datos",
      icon: "icon-update-date.svg",
      idOption: this.tabs.ActualizacionDatos,
    },
  ];

  constructor(
    public helper: HelperService,
    private pubSubService: PubSubService,
    private subject: SubjectService
  ) { }

  ngOnInit() {
    if (this.navItemTabs.length > 0) {
      this.currentTab = this.navItemTabs[0].idOption;
    }
  }

  setCurrentTab(item: { idOption: Tabs }) {
    this.currentTab = item.idOption;
  }

  setActiveQuota(value: boolean) {
    this.activeQuota = value;
  }

  refresh(item: { idOption: Tabs }) {
    if (item.idOption === Tabs.ActualizacionDatos) {
      this.pubSubService.sendMessage(true);
    } else {
      this.subject.removeFiles();
    }
  }

  onFormCancel() {
    this.activeQuota = false;
    this.currentTab = this.tabs.ActualizacionDatos;
    this.subject.removeFiles();
  }
}